import SoftwareCardList from './SoftwareCardList';

export default SoftwareCardList;
